// extracted by mini-css-extract-plugin
export default {"background":"Home_background__OAJIj","cards":"Home_cards__ezu4Z","sideBar":"Home_sideBar__E1UUZ","pagination":"Home_pagination__rsg0a"};